export enum Appconfig {
  CURRENTJWTTOKEN = 'currentJwtToken',
  CURRENTUSER = 'current_user',
  MYAPPS = 'myApps',
  MYSUBMENU = 'mySubMenu',
  APPCONFIG = 'appConfig',
  GRID_PROPS = 'gridProps',

  //Accounting Softwares
  QUICKBOOKS = "QBO",
  FRESHBOOKS = "FBO",
  XERO = "XER",
  SAGE = "SAG",
  NOACCSW = "NAS",
  CURRENT_APPCODE = "currentappcode",
  //invoice payments
  INVOICE_PAYMENTS = 'invoice-payments',

  //Main Apps
  HTF_MYORGANIZATION = 'my-organizations',
  HTF_TEAM = 'team',
  HTF_TEAM_PERFORMANCE = 'team_permormance',
  HTF_GROUPS = 'groups',
  HTF_MYSUBSCRIPTION = 'mysubscription',
  PERFORMANCE = 'performance',
  MAIN_CLIENT_TEAM = 'client-assign-team',
  MAIN_FU_CLIENTS = 'fu-clients',
  MAIN_CLIENT_MANAGEMENT_CA = 'client-management-ca',
  MAIN_CLIENT_MANAGEMENT_CB = 'client-management-cb',
  MAIN_CLIENT_MANAGEMENT_PORTAL = 'client-management-portal',
  MAIN_CLIENT_MANAGEMENT_CB_PROPOSALS = 'client-management-cb-for-proposals',
  MAIN_CLIENT_MANAGEMENT_NW = 'client-management-noworkspace',
  MAIN_CLIENT_MANAGEMENT_LIST = 'client-management-only-list',
  MAIN_CONTACTS_CUSTOMERS = 'contact-customers',
  MAIN_RETAINER = 'main-retainer',
  MAIN_TIMESHEET = 'main-timesheets',
  MAIN_EXPENSES = 'main-expenses',
  MAIN_CLIENT_MANAGEMENT_VERIFY = 'client-management-verify',
  MAIN_HT_MANAGEMENT_VERIFY = 'HT-management-verify',
  MAIN_CA_RECEIVABLES = 'ac-invoice-receivables',
  MAIN_FBO_CA_RECEIVABLES = 'FBO_ac-invoice-receivables',
  MAIN_CB_ACTIVITIES = 'cb-activities',
  CRM_CLIENT_HISTORY = 'crm-activity-history',
  PROPOSAL_ACTIVITY = 'proposal-activity',
  PROPOSAL_ID_ACTIVITY = 'proposal-id-activity',

  CRM_TASK_TIMER = 'crm-task-timer',
  CRM_TASK_TIMER_WITH_USER = 'crm-task-timer-with-user',


  //screens FW
  CATEGORY = 'category',
  ALLAPPSETTINGS = 'all-app-settings',
  DBTABLES = 'dbtables',
  VideoInput = 'video-input',
  CREATE_APPS = 'app-services',
  FW_STAKEHOLDERS = 'stakeholders',
  FW_STAKEHOLDERACTIVITIES = 'stakeholder-activities',

  MASTERDATA = 'masterdata',
  FW_ALL_ORGANIZAIONS = 'all-organizations',
  FW_ALL_CA_REQUESTS = 'ca-requests',
  FW_USAGE_METER = 'org-usage-meter',
  FW_USAGE_REPORT = 'org-usage-report',
  FW_USAGE_SUMMARY = 'org-usage-summary',
  FW_FEEDBACKS = 'feedbacks',
  FW_HELP = 'help',
  FW_NOTIFICATION = 'notifications',
  FW_SERVICEBANK = 'servicebank',
  FW_USAGE_MASTER = 'usage-master',
  FW_HTML_TEMPLATES = 'html-templates',
  LM_LICENSES_INFO = 'licenses-info',
  FW_MY_SUBSCRIPTIONS = 'org-subscriptions',
  FW_JOURNALENTRIES = 'journal-entries',
  FW_MY_EXPENSES = 'my-expenses',
  FW_SERVICE_LOG = 'service-log',
  FW_WEBHOOK_LOG = 'webhook-log',
  FW_USER_LOG = 'user-log',
  STRIPE_SUBSCRIPTIONS = 'client-subscriptions',
  CAMPAIGN_SOURCETABLE_DATA = 'campaign-sourcetable-data',

  // Knowledge share
  AI_TOKENS_USAGE = 'ai-tokens-usage',
  BLOB_TOKENS_USAGE = 'blob-tokens-usage',
  WALLET_AI_TOKENS_USAGE = 'wallet-ai-tokens-usage',
  WALLET_BLOB_TOKENS_USAGE = 'wallet-blob-tokens-usage',
  AI_TOKENS_USAGE_DETAILED = 'ai-token-usage-detailed',
  ACTIVITIES_DETAILED = 'activities-detailed',
  FILES_USAGE_DETAILED = 'files-usage-detailed',
  MEMBERSHIP_USAGE_DETAILED = 'membership-usage-detailed',
  COGNITIVE_USAGE_DETAILED = 'cognitive-usage-detailed',
  COGNITIVE_USAGE_SUMMARY = 'cognitive-usage-summary',
  FILES_USAGE_SUMMARY = 'files-usage-summary',
  MEMBERSHIP_USAGE_SUMMARY = 'membership-usage-summary',
  AI_TUTOR_SHARE = 'ai-tutor-share',
  ROOM_INVITE = 'room-invite',
  WALLET_ACTIVITY = 'wallet-activity',
  PAYMENTS_GATEWAY = 'payments-gateway',
  AI_TUTORS_REPORT = 'ai-tutors-report',
  ROOMS_REPORT = 'rooms-report',
  AI_TUTORS_REPORT_BYID = 'ai-tutors-report-byid',
  ROOMS_REPORT_BYID = 'rooms-report-byid',
  STAFF_REPORT = 'staff-report',
  CERTIFICATIONS_DETAILS = 'certifications-details',
  CASHFLOW_DETAILS = 'cashflow-details',
  PAIDSERVICES_DETAILS = 'paidservices-details',
  SUBSCRIPTION_DETAILS = 'subscription-details',
  SUBSCRIPTION_LIST_DETAILS = 'subscription-list-details',
  //Screens CRM
  CRM_ALERTS = 'alerts',
  CRM_CONTACTS = 'contacts',
  CRM_OPPORTUNITIES = 'opportunities',
  CRM_LEADSOURCE = 'lead-source',
  CRM_SALESPIPELINE = 'sales-pipeline',
  CRM_ITEMS = 'items',
  CRM_MASTERDATA = 'masterdata',
  CRM_ESTIMATE = 'estimate',
  CRM_TEMPLATEBANK = 'templatebank',
  CRM_TEMPLATE = 'template',
  CRM_MY_ACTIVITIES = 'myactivities',
  CRM_GROUP_ACTIVITIES = 'group-activities',
  CRM_ALL_ACTIVITIES = 'all-activities',
  CRM_CLOSED_ACTIVITIES = 'closed-activities',
  CRM_MY_ACTIVITILINES = 'myactivitilines',
  CRM_GROUP_ACTIVITILINES = 'group-activitilines',
  CRM_ALL_ACTIVITILINES = 'all-activitilines',
  CRM_CLOSED_ACTIVITILINES = 'closed-activitilines',
  CRM_CLIENT_ISSUES = 'client-issues',
  CRM_CLIENT_ISSUES_NO_CLIENT = 'client-issues-no-client',

  //Screens Email-Read
  ER_CUSTOMERS = 'customers',

  // Screens Email Campaign
  EC_MASTER_DATA = 'masterdata',
  EC_EMAIL_BANK = 'emailbank',
  EC_EMAIL_BANK_WITH_GROUP = 'emailbank-with-group',
  EC_EMAILCAMPAIGN = 'emailcampaign',
  EC_TEMPLATE = 'emailtemplate',
  EC_CONTACTS = 'ec-contacts-list',
  //Screens Jobs
  JS_MYJOBS = 'my-jobs',
  JS_MYJOBSMATCHED = 'my-jobs-matched',
  JS_INPROCSESSJOBS = 'Submitted Proposals',
  JS_DRAFTSJOBS = 'Drafts',
  JS_SHORTLISTEDJOBS = 'my-jobs-shortlisted',
  JS_SELECTEDJOBS = 'Accepted Proposals',
  JS_SELECTEDJOBS_SIGNOFF = 'Signed Proposals',
  JS_REJECTEDJOBS = 'Rejected',
  JS_CLOSEDJOBS = 'Contracted',
  JS_SAVED_JOBS = 'js-saved-job',
  JS_INVITED_JOBS = 'invite-ca',
  JS_INVITEDCB = 'invite-cb',
  JS_ORG_USER_PROFILE = 'org-user-profiles',
  JS_SAVEDAC = 'js-accountant-job',
  JS_INVITE = 'invite-ca',
  JS_PAYMENTS = 'payments',
  JS_CHAT = 'ca-chat',
  JS_PROPOSALS_MATCHED = 'proposals-matched',
  JS_REJECTED = 'Rejected',
  JS_SELECTED = 'Accepted Proposals',
  JS_SHORTLISTED = 'proposals-shortlisted',
  JS_MATCHED = 'proposals-matched',
  JS_INPROCESS = 'Received Proposals',
  JS_MYCLOSEDJOBS = 'my-jobs-closed',
  JS_MYJOBSPOSTED = 'my-jobs',
  JS_MYJOBSDRAFT = 'my-jobs-draft',
  // Screen Accountant
  AC_JOBS = 'jobs',
  AC_REPORTS_TIMER_SUMMARY = 'ac-reports-timer-summary',
  AC_REPORTS_TIMER_DETAILS = 'ac-reports-timer-details',
  AC_REPORTS_CLIENT_TASK_FILES = 'ac-reports-client-task-files',
  AC_REPORTS_TEAM_ACTIVITY = 'ac-reports-team-activity',
  AC_JOBS_NO_CLIENT = 'jobs-no-client',
  AC_JOBS_TOPS = 'jobs-tabs',
  AC_JOBTASKS = 'jobtasks',
  AC_All_JOBTASKS = 'all-jobtasks',
  AC_MILESTONES = 'milestones',
  AC_APPROVALS = 'approvals',
  AC_STAFF = 'staff',
  AC_STAFF_LOCATION = 'staff-location',
  AC_RETAINER = 'retainer',
  AC_CONTRACTS = 'contracts',
  AC_JOB_CONTRACTS = 'contracts-job',
  AC_JOB_NO_CONTRACTS = 'contracts-no-job',
  AC_PBC_LISTS = 'pbc-lists',
  AC_TIMESHEETS = 'timesheets',
  AC_STAFF_RATES = 'staff-rates',
  AC_CUSTOMERTEAM = 'ac-customers',
  AC_CUSTOMER = 'customers',
  AC_TEMPLATE = 'templates',
  AC_PBC_TEMPLATE = 'pbc-templates',
  AC_ALERTS = 'alerts',
  AC_MASTERDATA = 'masterData',
  AC_SERVICE_BANK = 'ac-service-bank',
  AC_TEMPLATES_LIBRARY = 'ac-templates-library',
  AC_JOBTASK_TIMER = 'ac-jobtask-timer',
  AC_TASK_TIMER = 'ac-task-timer',
  AC_JOBTASK_TIMESHEET = "ac-jobtask-timesheet",
  AC_JOBTASK_EXPENSES = 'ac-jobtask-expenses',
  AC_JOBTASK_EXPENSES_NO_CLIENT = 'ac-jobtask-expenses-noclient',
  AC_JOBTASK_EXPENSES_NO_JOB = 'ac-jobtask-expenses-noJob',
  AC_JOBTASK_EXPENSES_NO_TASK = 'ac-jobtask-expenses-noTask',
  AC_JOBTASK_EXPENSES_FROM_TASK_MODEL = 'ac-jobtask-expenses-fromModel',
  AC_JOBTASK_ISSUES = 'ac-jobtask-issues',
  AC_JOBTASK_COMMENTS = 'ac-jobtask-comments',
  AC_JOBTASK_APPROVALS = 'ac-jobtask-approvals',
  AC_JOBTASK_ALERTS = 'ac-jobtask-alerts',
  AC_JOB_COMMENTS = 'ac-job-comments',
  AC_JOB_MILESTONES = 'ac-job-milestones',
  AC_JOB_AERTS = 'ac-job-alerts',
  AC_PAYMENTS = 'ac-payments',
  AC_ISSUES = 'ac-issues',
  AC_PAYMENTS_LIST = 'ac-payments-list',
  AC_PAYMENTS_Data = 'ac-payments-data',
  AC_SP_SERVICES = 'ac-sp-services',
  AC_SP_PACKAGES = 'ac-sp-packages',
  AC_SP_TERMS = 'ac-sp-terms',
  AC_SP_PROPOSALS = 'ac-proposals',
  AC_SP_PROPOSALS_NO_CLIENT = 'ac-proposals-no-client',
  AC_PRICING_TOOL_ROLES = 'ac-tool-roles',
  ACCOUNTANT_PRICE_BOOK_CLIENTS = 'price-book-clients',



  // Screens for OM
  OM_ALERT = 'alertData',
  OM_MASTER_DATA = 'masterData',
  OM_MY_CONTRACTS = 'myContracts',
  OM_MY_GROUP_CONTRACTS = 'myGroupContracts',
  OM_ALL_CONTRACTS = 'allContracts',
  OM_CLOSED_CONTRACTS = 'closedContracts',
  OM_FILLING_LIST = 'MyFilingLists',
  OM_GROUP_FILLING = 'groupFiling',
  OM_ALL_FILLING = 'allFiling',
  OM_CLOSED_FILLING = 'closedFiling',
  OM_FILLING_TASK_LIST = 'MyFilingTaskLists',
  OM_GROUP_TASK_FILLING = 'groupFilingTask',
  OM_ALL_TASK_FILLING = 'allFilingTask',
  OM_CLOSED_TASK_FILLING = 'closedFilingTask',
  OM_SERVICE_BANK = 'om-service-bank',
  OM_FILLING_TEMPLATES = 'om-fillingtemplates',
  OM_MINUTES = 'om-minutes',

  //Be An Advisor
  AD_PAYMENT = 'payments',
  AD_PROPOSED = 'proposed',
  AD_MYACTIVITY = 'myactivity',
  AD_PAYMENT_LINES = 'paymentlines',

  //Dynamic forms
  DF_ALLFORMS = 'allforms',
  DF_QUESTION = 'questionbank',

  FORM_ASSIGNED_CLIENTS = "form-assigned-clients",

  // Business directory
  BD_FAVORITE_ENTITY = 'myfavorites',
  BD_ENTITY_SEARCH = 'entity-search',
  BD_NAICS = 'naics',

  //VC_Portal
  VC_CUSTOMERS = 'fu-clients',
  VC_VENDORS = 'vendors',
  VC_INVITATIONS = 'invitations',
  VC_ACTIVITIES = 'activities',
  PORTAL_PROADVISORSDATA = 'proadvisors-data-entry',

  // audits
  AUDIT_TEMPLATES = 'aud-templates',
  AUD_AUDIT_TEMPLATES = 'aud-audit-templates',
  AUD_MILEsTONES = 'aud-milestones',
  AUD_MY_JOBTASKS = 'aud-my-jobtask',
  AUD_ALL_JOBTASKS = 'aud-all-jobtask',
  AUDIT_APPROVALS = 'aud-approvals',
  AUDIT_JOBS = 'aud-jobs',
  AUDIT_JOBS_AERTS = 'aud-jobs-alerts',
  AUDIT_JOBS_CONTRACTS = 'aud-jobs-contacts',
  AUDIT_JOBS_MILESTONES = 'aud-jobs-milestones',
  AUDIT_JOBS_COMMENTS = 'aud-jobs-comments',
  AUDIT_JOBTASK_COMMENTS = 'aud-jobtask-comments',
  AUDIT_JOBTASK_TIMER = 'aud-jobtask-timer',
  AUD_JOBTASK_APPROVALS = 'aud-jobtask-approvals',
  AUDIT_JOBTASK_TIMESHEET = "aud-jobtask-timesheet",
  AUDIT_JOBTASK_ALERTS = 'aud-jobtask-alerts',
  AUDIT_JOBTASK_EXPENSES = 'aud-jobtask-expenses',
  AUDIT_NON_CONFORMANCE = 'aud-non-conformance',
  AUDIT_JOBTASK_ROOTCAUSE = 'aud-jobtasks-rootcause',
  AUDIT_JOBTASK_CAPA = 'aud-jobtasks-capa',
  AUDIT_JOBS_NONCONFORMANCE = 'aud-jobs-nonconformance',
  AUDIT_JOBS_ROOTCAUSE = 'aud-jobs-rootcause',
  AUDIT_JOBS_CORRECTIVE_OR_PREVENTIVEACTIONS = 'aud-jobs-corrective-or-prevention',

  // lm
  LM_MILESTONES = 'lm-milestones',
  LM_APPROVALS = 'lm-approvals',
  LM_ISSUES = 'lm-issues',
  LM_SERVICE_BANK = 'lm-service-bank',
  LM_TEMPLATE = 'lm-templates',
  LM_JOBS = 'jobs',
  LM_JOBTASKS = 'jobtasks',
  LM_All_JOBTASKS = 'all-jobtasks',
  LM_JOB_COMMENTS = 'lm-job-comments',
  LM_JOB_CONTRACTS = 'lm-job-contracts',
  LM_JOB_AERTS = 'lm-job-alerts',


  //Fix Uncat
  FU_TRXLIST = 'trxs-list',

  //Connections
  Share_Activity = 'shares-activity',

  BD_CLIENT_GROUPS = 'bd-client-groups',
  BD_CLIENT_GROUP_DATA = 'client-groups-data',

}